export default __webpack_public_path__ + "static/media/CJPF.d6f4a528.png";